import { render, staticRenderFns } from "./ArchiveEvents.vue?vue&type=template&id=3126a0c4&scoped=true"
import script from "./ArchiveEvents.vue?vue&type=script&lang=js"
export * from "./ArchiveEvents.vue?vue&type=script&lang=js"
import style0 from "./ArchiveEvents.vue?vue&type=style&index=0&id=3126a0c4&prod&lang=scss&scoped=true"
import style1 from "./ArchiveEvents.vue?vue&type=style&index=1&id=3126a0c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126a0c4",
  null
  
)

export default component.exports